import React from "react";
import {
  FaPhone,
  FaTag,
  FaArrowRight,
  FaCheck,
} from "react-icons/fa";
import "./Offer.css";

export default function Offer() {
  const PHONE = "+919318333680";

  return (
    <section className="rk-offer">

      <div className="rk-offer-wrap">

        {/* Background Decorations */}
        <div className="rk-offer-orb rk-offer-orb-one"></div>
        <div className="rk-offer-orb rk-offer-orb-two"></div>

        {/* LEFT DISCOUNT */}
        <div className="rk-offer-discount">

          <div className="rk-offer-discount-top">
            <FaTag />
            <span>SPECIAL OFFER</span>
          </div>

          <div className="rk-offer-number">
            20<span>%</span>
          </div>

          <div className="rk-offer-off">
            OFF
          </div>

          <div className="rk-offer-circle-text">
            FIRST<br />
            SERVICE
          </div>

        </div>


        {/* CENTER CONTENT */}
        <div className="rk-offer-main">

          <span className="rk-offer-kicker">
            LIMITED TIME · NOIDA
          </span>

          <h2>
            Your Old Sofa
            <br />
            <span>Deserves a New Life.</span>
          </h2>

          <p>
            Give your sofa a premium makeover with expert repair,
            fabric change, foam replacement and upholstery services
            from RK Sofa Works.
          </p>

          <div className="rk-offer-features">

            <div>
              <FaCheck />
              <span>Expert Workmanship</span>
            </div>

            <div>
              <FaCheck />
              <span>Doorstep Service</span>
            </div>

            <div>
              <FaCheck />
              <span>Premium Finish</span>
            </div>

          </div>

        </div>


        {/* RIGHT CTA */}
        <div className="rk-offer-cta">

          <div className="rk-offer-cta-line"></div>

          <span className="rk-offer-cta-small">
            READY TO RESTORE?
          </span>

          <h3>
            Book Your
            <br />
            Service Today
          </h3>

          <a
            href={`tel:${PHONE}`}
            className="rk-offer-btn"
          >
            <FaPhone />
            <span>Call Now</span>
            <FaArrowRight />
          </a>

          <small className="rk-offer-note">
            *For new customers only
          </small>

        </div>

      </div>

    </section>
  );
}
